import moment from "jalali-moment";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import endpoints from "../../config/endpoints";
import orderEnum from "../../enums/orderEnum";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import { Sidebar } from "../../layouts/Sidebar";
import tools from "utils/tools";
import DataTable, { Column } from "components/DataTable";

const Product = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [data, setData] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [tab, setTab] = useState("all");
  const itemsPerPage = 25;
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = data
    .filter((e) => e.title?.toLowerCase()?.includes(query.toLowerCase()))
    ?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);
  const [tableLoading, setTableLoading] = useState(false);

  const tabTitles = {
    all: "همه",
    product: "محصول",
    pre: "پیش محصول",
  };

  const deleteItem = async (id: number) => {
    if (confirm("آیا مطمئن هستید؟")) {
      dispatch(setLoading(true));

      const res = await restApi(endpoints.product.index + id, true).delete({});

      if (res.code == 204) {
        Swal.fire({
          title: "موفق",
          text: "محصول با موفقیت حذف شد",
          icon: "success",
          confirmButtonText: "متوجه شدم",
        });
        await fetchData();
      } else {
        Swal.fire({
          title: "ناموفق",
          text: res?.data,
          icon: "error",
          confirmButtonText: "متوجه شدم",
        });
      }
      dispatch(setLoading(false));
    }
  };

  const columns: Column[] = [
    {
      key: "mainImage",
      title: "عکس",
      sortable: false,
      searchable: false,
      render: (val, row) => (
        <img
          src={val || (row.medias?.length > 0 && row.medias[0]?.url)}
          className="width100p"
        />
      ),
    },
    {
      key: "code",
      title: "کد محصول",
      sortable: true,
      searchable: true,
    },
    {
      key: "title",
      title: "عنوان",
      sortable: true,
      searchable: true,
    },
    {
      key: "slug",
      title: "اسلاگ",
      sortable: true,
      searchable: true,
    },
    {
      key: "status",
      title: "وضعیت",
      sortable: true,
      searchable: false,
      render: (val) => (val == "1" ? "موجود" : "ناموجود"),
    },
    {
      key: "createdAt",
      title: "تاریخ",
      sortable: true,
      searchable: false,
      render: (val) =>
        val ? tools.engNumToPersian(moment(val).format("jYYYY/jMM/jDD")) : "—",
    },
    {
      key: "price",
      title: "قیمت",
      sortable: true,
      searchable: false,
      render: (val) => tools.engNumToPersian(tools.formatPrice(val)),
    },
    {
      key: "weight",
      title: "وزن (گرم)",
      sortable: true,
      searchable: false,
      render: (val) => (val ? tools.engNumToPersian(val) : "—"),
    },
    {
      key: "actions",
      title: "عملیات",
      sortable: false,
      searchable: false,
      width: "140px",
      render: (_, row) => (
        <div className="svgContainer">
          <i className="trash clickable" onClick={() => deleteItem(row.id)}></i>
          <i
            className="edit clickable"
            onClick={() => navigate("/product/edit/" + row.id)}
          ></i>
          <i
            className="copy clickable"
            onClick={() => navigate("/product/add/" + row.id)}
          ></i>
          <a
            href={`${process.env.REACT_APP_CLIENT_URL}/product/${row?.slug}`}
            target="_blank"
          >
            <i className="eye clickable"></i>
          </a>
        </div>
      ),
    },
  ];

  const list = () => {
    const rows = [];

    currentItems
      .filter((e) => e.code?.includes(query))
      .filter((e: any) => {
        switch (tab) {
          case "product":
            return e.isPre == false;
          case "pre":
            return e.isPre == true;
          default:
            return true;
        }
      })
      .sort(
        (a, b) =>
          new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf(),
      )
      ?.map((product: any, index) => {
        rows.push(
          <tr className="dashTr2">
            <td className="">
              <i
                className="trash clickable"
                onClick={() => deleteItem(product.id)}
              ></i>
              <i
                className="edit clickable"
                onClick={() => navigate("/product/edit/" + product.id)}
              ></i>
              <i
                className="copy clickable"
                onClick={() => navigate("/product/add/" + product.id)}
              ></i>
              <a
                href={`${process.env.REACT_APP_CLIENT_URL}/product/${product?.slug}`}
                target="_blank"
              >
                <i className="eye clickable"></i>
              </a>
            </td>
            <td>{product?.sort}</td>
            <td className="">{product?.code}</td>
            <td>
              {product?.products?.length > 0
                ? product?.products[0]?.price
                : "-"}
            </td>
            <td className="">
              <p>{moment(product?.updatedAt).format("jYYYY/jMM/jDD")}</p>
              <p>{moment(product?.updatedAt).format("HH:ss")}</p>
            </td>
            <td className="">{product?.title}</td>
            <td>
              <img
                src={product.medias?.length > 0 && product.medias[0]?.url}
                className="width100p"
              />
            </td>
            <td>{++index}</td>
          </tr>,
        );
      });

    return rows;
  };

  const tabFilter = (product) => {
    switch (tab) {
      case "product":
        return product.isPre == false;
      case "pre":
        return product.isPre == true;
      default:
        return true;
    }
  };
  const fetchData = async () => {
    dispatch(setLoading(true));
    setTableLoading(true);
    const res = await restApi(endpoints.product.index, true).get();

    if (res.code == 200) {
      setData(
        [...res.data].sort(
          (a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
        ),
      );
    }

    dispatch(setLoading(false));
    setTableLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredData = [...data].filter(tabFilter).sort((a, b) => b.id - a.id);

  return (
    <>
      <main className="dashboardBody">
        <Sidebar />
        <div className="dashBoardMain">
          <h1 className="dashBoardTitle">لیست محصولات</h1>
          <div className="dashTabs">
            {Object.entries(tabTitles).map(([key, value]) => (
              <span
                className={`ordersTag ${key == tab ? "activeTab" : ""}`}
                onClick={() => setTab(key)}
              >
                {value}
                <span className={`numberTag ${key == tab ? "activeTab" : ""}`}>
                  {
                    data?.filter((e: any) => {
                      switch (key) {
                        case "product":
                          return e.isPre == false;
                        case "pre":
                          return e.isPre == true;
                        default:
                          return true;
                      }
                    }).length
                  }
                </span>
              </span>
            ))}
          </div>
          <div className="searchContainer">
            <div className="keepRight svgContainer">
              <span
                className="dashboardHeader clickable"
                onClick={() => navigate("/product/add")}
              >
                <p>افزودن محصول جدید</p>
                <i className="addPlus"></i>
              </span>
              <span
                className="dashboardHeader clickable"
                onClick={() => navigate("/product/bulk")}
              >
                <p>تغییر گروهی قیمت و وضعیت</p>
              </span>
            </div>
          </div>

          {/* Table */}
          <div className="dashCard">
            <DataTable
              columns={columns}
              data={filteredData}
              pageSize={15}
              loading={tableLoading}
              rowKey="id"
            />
          </div>
        </div>
      </main>
    </>
  );
};
export default Product;
